import React from 'react'
import { LoadingBar } from 'components/Loading'
import styles from '../DataTable.module.scss'

export default ({ loading, loadingText }) => (loading ?
	<LoadingBar className={styles.loading} /> : null
)
